import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const ICONS = [
  '2g',
  '3g',
  '4g',
  '5g',
  'battery-0',
  'battery-1',
  'battery-2',
  'battery-3',
  'battery-4',
  'battery-charging',
  'network-signal',
  'tt-logo',
  'pie-chart',
  'helmet',
  'user',
  'users',
  'archive',
  'attention-bubble',
  'arrow-down',
  'dropdown-arrow',
  'home',
  'location',
  'bar-chart',
  'document',
  'car',
  'notifications',
  'checkbox-empty',
  'checkbox-checked',
  'search',
  'fullscreen',
  'video-camera',
  'radio-empty',
  'radio-checked',
  'calendar',
  'cloud',
  'memory',
  'check',
  'refresh',
  'device-remote',
];

export function provideSvgIcons(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const registry = inject(MatIconRegistry);
    const ds = inject(DomSanitizer);

    ICONS.forEach((icon) => registry.addSvgIcon(icon, ds.bypassSecurityTrustResourceUrl(`/assets/svg/${icon}.svg`)));
  });
}
